import * as classnames from 'classnames/bind'
import * as React from 'react'
import { FC } from 'react'
import { isEmpty } from 'lodash'
import Button from './button'
import Recruiter from 'entities/recruiter'
import styles from './recruiter_search_completion.module.scss'

type Props = {
  keyword: string
  recruiters: Recruiter[]
  selectedRecruiter: Recruiter | null
  onSelectRecruiter: (recruiter: Recruiter) => void
}

const cx = classnames.bind(styles)
const RecruiterSearchCompletion: FC<Props> = ({ keyword, recruiters, selectedRecruiter, onSelectRecruiter }) => {
  if (isEmpty(recruiters) || isEmpty(keyword)) {
    return null
  }

  return (
    <div className={styles.searchCompletion}>
      <ul className={styles.searchCompletionList}>
        {recruiters.map(recruiter => {
          const { name } = recruiter
          const isSelected = selectedRecruiter === null ? false : recruiter.id === selectedRecruiter.id
          const className = cx(styles.searchCompletionListItem, {
            searchCompletionListItemSelected: isSelected
          })

          return (
            <li key={recruiter.id} className={className}>
              <Button className={styles.button} disabled={isSelected} onClick={() => onSelectRecruiter(recruiter)}>
                {name}
              </Button>
            </li>
          )
        })}
      </ul>
    </div>
  )
}

export default RecruiterSearchCompletion
